import { render } from "./MultiPortalView.vue?vue&type=template&id=094c329a&scoped=true"
import script from "./MultiPortalView.vue?vue&type=script&lang=js"
export * from "./MultiPortalView.vue?vue&type=script&lang=js"

import "./MultiPortalView.vue?vue&type=style&index=0&id=094c329a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094c329a"]])

export default __exports__